// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__19MXT","author":"Table_author__hw38Q","authorImage":"Table_authorImage__OgqoM","unreadRow":"Table_unreadRow__15W-R"};